import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntityProfileFoldout from 'components/organisms/Foldouts/EntityProfileFoldout/EntityProfileFoldout';

const StyledDealflowEntityProfileFoldout = styled(EntityProfileFoldout)`
  ${ComponentStyles}
`;

StyledDealflowEntityProfileFoldout.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntityProfileFoldout;
